import { Record, List } from 'immutable';
import { tFunctionType } from 'app/components/localization';
import { Ability } from 'app/constants/enums/Ability';
import { convertAudioBlob } from 'app/utils/audioConversion';

export class MediaType extends Record<{
  name: string,
  mimes: List<string>,
  converter: ((file: Blob) => Promise<Blob>) | null,
}>({
  name: '',
  mimes: List(),
  converter: null,
}, 'MediaType') {}

export class AbilityGroup extends Record<{
  id: string,
  getName: (t: tFunctionType) => string,
  abilities: List<Ability>,
}>({
  id: '',
  getName: (t) => '',
  abilities: List<Ability>(),
}, 'AbilityGroup') {}

export const JPEG = new MediaType({
  name: 'JPEG',
  mimes: List(['image/jpeg']),
});
export const PNG = new MediaType({
  name: 'PNG',
  mimes: List(['image/png']),
});
export const GIF = new MediaType({
  name: 'GIF',
  mimes: List(['image/gif']),
});

export const SVG = new MediaType({
  name: 'SVG',
  mimes: List(['image/svg+xml']),
});

export const MP3 = new MediaType({
  name: 'MP3',
  mimes: List(['audio/mpeg', 'audio/mp3']),
  converter: convertAudioBlob,
});

export const WAV = new MediaType({
  name: 'WAV',
  mimes: List(['audio/wav', 'audio/x-wav']),
  converter: convertAudioBlob,
});

export const PDF = new MediaType({
  name: 'PDF',
  mimes: List(['application/pdf']),
});

export const CSV = new MediaType({
  name: 'CSV',
  mimes: List(['text/csv']),
});

export const CSV_TYPES = List([CSV]);
export const PDF_TYPES = List([PDF]);
export const IMAGE_TYPES = List([JPEG, PNG, GIF]);
export const SOUND_TYPES = List([MP3, WAV]);
export const LOGO_TYPES = List([SVG]);
export const NATIVE_SOUND_TYPES = List([MP3]);
export const MEDIA_TYPES = IMAGE_TYPES.concat(SOUND_TYPES);
export const CALL_UPLOAD_TYPES = IMAGE_TYPES.concat(PDF_TYPES);

export const createMimeFinder = (types: List<MediaType>) => (type: string) => types.find(
  ({ mimes }) => Boolean(mimes.find(mime => mime === type)),
);

export const isNativeImageMimeType = createMimeFinder(IMAGE_TYPES);
export const isNativeSoundMimeType = createMimeFinder(NATIVE_SOUND_TYPES);
export const isPDF = createMimeFinder(PDF_TYPES);
export const isCSV = createMimeFinder(CSV_TYPES);

export const IMAGE_TYPE_NAMES = IMAGE_TYPES.map(({ name }) => name).join(', ');
export const SOUND_TYPE_NAMES = SOUND_TYPES.map(({ name }) => name).join(', ');

export default MEDIA_TYPES;
